module.exports = __webpack_public_path__ + "img/bottlesFar_thumb.7f61603d.jpg";